module.exports = __webpack_public_path__ + "img/img108.e1a611a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/franchise/UniLogo/img108.jpg
// module id = 1780
// module chunks = 1